interface LoadMoreChannelsErrorProps {
  onRetry: () => void;
}

/** A later page of channels gave up; the loaded ones stay selectable. */
export const LoadMoreChannelsError = ({
  onRetry,
}: LoadMoreChannelsErrorProps) => (
  <p className="text-muted-foreground text-[13px] leading-[18px]">
    Couldn&rsquo;t load more channels.{' '}
    <button
      type="button"
      className="text-foreground font-medium underline underline-offset-2 hover:no-underline"
      onClick={onRetry}
    >
      Try again
    </button>
  </p>
);
